import type { ZodError } from "zod";

import type { ReactNode } from "react";

import { VStack } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { totpResetSearchMessages } from "@app/navigation/routes/messages.ts";
import { commonMessages } from "@shared/i18n/common-messages.ts";
import { useFormatErrorMessages } from "@shared/libs/validators/hooks/use-format-error-messages.ts";
import { Button } from "@shared/ui/chakra/buttons/button";
import { Typography } from "@shared/ui/chakra/typography/typography";
import { PageTemplate } from "@shared/ui/templates/page-template";

import { searchParamErrorPageMessages } from "./messages";

type Props = {
  error: ZodError;
  navigationSlot?: ReactNode;
  onGoBack: () => void;
};

export const SearchParamErrorPage = ({
  error,
  navigationSlot,
  onGoBack,
}: Props) => {
  const formatErrorMessage = useFormatErrorMessages([totpResetSearchMessages]);
  return (
    <PageTemplate navigationSlot={navigationSlot}>
      <VStack alignItems="center">
        <Typography textStyle="h3">
          <FormattedMessage {...searchParamErrorPageMessages.invalidFormat} />
        </Typography>
        <Typography textStyle="title">
          <FormattedMessage {...searchParamErrorPageMessages.urlErrors} />
        </Typography>
        {error.issues.map((issue) => (
          <Typography>
            {issue.path.join(", ")}: {formatErrorMessage(issue.message)}
          </Typography>
        ))}
        <Button onClick={onGoBack}>
          <FormattedMessage {...commonMessages.continue} />
        </Button>
      </VStack>
    </PageTemplate>
  );
};
